<template>
  <el-container class="common-layout">
    <el-header class="layout_header" height="64px">
      <module-header class="fade_top"></module-header>
    </el-header>

    <el-container class="h-[calc(100%-64px)]">
      <el-aside width="200px" class="menu-side bg-white hidden sm:block"
        style="box-shadow: 2px 0px 4px 0px rgba(1, 78, 127, 0.1)">
        <MenuSide :list="menuList"></MenuSide>
      </el-aside>
      <el-main class="p-0">
        <el-scrollbar class="main_scrollbar">
          <Suspense>
            <router-view class="router-view" #default="{ Component }">
              <transition name="fade_offset_left" mode="out-in" appear>
                <div class="h-full">
                  <div class="mb-2 flex justify-between">
                    <img @click="toggleMenu"
                      :src="commonStore.base_url + commonStore.dataBrand + '/images/module-header.png'" alt="logo"
                      class="block w-[165px] sm:hidden">
                  </div>
                  <component :is="Component"></component>
                </div>
              </transition>
            </router-view>
          </Suspense>
        </el-scrollbar>
      </el-main>

      <!-- <el-footer>Footer</el-footer> -->
    </el-container>
    <el-drawer v-model="menuFloat" size="70%" :with-header="false"  direction="ltr">
      <MenuSide :list="menuList"></MenuSide>
    </el-drawer>
  </el-container>
</template>

<script lang="ts" setup>
import MenuSide from "./menu.vue";
import moduleHeader from "./module-header.vue";
import { ElContainer, ElAside, ElMain, ElFooter, ElHeader } from "element-plus";
import { ref, Suspense } from "vue";
// import SubMenu from './sub-menu.vue'
import { storeToRefs } from "pinia";
import { useRouterStore, useCommonStore } from "../store";
const commonStore = useCommonStore();
const routesStoreIns = useRouterStore();
const { menuList } = storeToRefs(routesStoreIns);
const menuFloat = ref(false)

const toggleMenu = () => {
  menuFloat.value = true
}


</script>

<style lang="scss" scoped>
.common-layout {
  height: 100%;
  background-color: #f9f9f9;

  .layout_header {
    box-shadow: 2px 0px 4px 0px rgba(1, 78, 127, 0.2);
    padding: 0 35px 0 17px;
    z-index: 1;
    background-color: #fff;
  }

  .menu-side {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

/* fade_offset */
.fade_offset_left-leave-active,
.fade_offset_left-enter-active {
  transition: all 0.3s;
}

.fade_offset_left-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade_offset_left-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.fade_top {
  animation: fade_enter_top 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);

  @keyframes fade_enter_top {
    from {
      transform: translateY(-10px);
      opacity: 0;
    }

    to {
      transform: translateY(0);
    }
  }
}

:deep(.main_scrollbar)>.el-scrollbar__wrap>.el-scrollbar__view {
  padding: 20px;
  height: 100%;
}
</style>
